module.exports = __webpack_public_path__ + "static/media/Pedro_G@3x.4d3cfba4.jpg";